module.exports = __webpack_public_path__ + "static/img/48.45fc8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/48.png
// module id = aYlk
// module chunks = 0